<app-esqueleto-tableros>
  <div titulo class="encabezadosSeparacion" [matTooltip]="'menu.' + dataService.subModuleSelect | translate ">
    <span class="headerCintilla1">{{ "menu." + dataService.moduleSelect | translate }}</span>
    <span class="bullSeparation">&bull;</span>
    <span class="headerCintilla2">{{ "menu." + dataService.subModuleSelect | translate }}</span>
  </div>
  <!-- FILTROS -->
  <!-- Filtro de Períodos -->
  <app-filters filtros [name]="'filtros.per' | translate" [array]="Periodos" [typeFilter]="Filters.PERIOD" 
    [click]="true" (eventClick)="cambioPeriodo($event)">
  </app-filters>
  <!-- Filtro de Escenarios -->
  <app-filters filtros [name]="'proyFinanciera.escenarioProyeccion.escenario' | translate"
    [array]="escenariosShow" [typeFilter]="Filters.ESCENARIOS" [click]="false"
    (eventClick)="escenarioChange($event)">
  </app-filters>
  <!-- Filtro de Sucursales -->
  @if(sucursales.length > 1){
    <app-filters filtros [name]="'filtros.sucursales'+tagInstitucion | translate" [array]="sucursales"
      [typeFilter]="Filters.ESCENARIOS" [click]="false"
      (eventClick)="sucursalChange($event)">
    </app-filters>
  }
   <!-- CONTENIDO -->
  <div contenido class="zonaContenido">
    <div class="w3-row w3-header-cuadrante">
      <div class="w3-half hijoIzquierdaTitle w3-titulo-contenidomenu">
        <div class="hijoizquierdaTitle">
          <span class="w3-margin-left-contenido">{{'segPresupuestal.catalogoCuentas.cuentas' | translate}}</span>
          <span class="w3-punto-subtitulo w3-margin-left-filter">&bull;</span><span class=" w3-margin-left-filter"></span>
          @for(p of periodosData; track $index){
            <span class="w3-subtitulo">{{ p?.nombre}} | </span>
          }
          <span class=" w3-margin-left-filter w3-subtitulo">{{ escenarioSeleccionado?.name }}</span>
        </div>
      </div>
      <div class="w3-rest w3-right-align_rest">
        <mat-icon class="w3-button w3-margin-right-contenido" [ngStyle]="{'color':'gray', 'cursor': 'pointer'}"
          [matMenuTriggerFor]="opcionesTabla" matTooltip="Más opciones">
          more_vert
        </mat-icon>
        <!-- Menú Más opciones con Exportar y Métrica -->
        <mat-menu #opcionesTabla="matMenu">        
          <button class="mat-menu-item w3-caja-menu" mat-menu-item (click)="exportarTabla()">
            <mat-icon class="material-icons-outlined" [ngStyle]="{'color':'gray'}">description</mat-icon>
            <span>{{'menu.Exportar'|translate}}</span>
          </button>                    
        </mat-menu>
      </div>
    </div>
    <div class="containerAll w3-white w3-scroll">
      <div >
        @if (cuentasVisibles.length === 0) {<app-skeleton-table [columnas]="6" [filas]="14"/>}
        @else {
          <table class="w3-table">
            <thead>
              <tr class="w3-table-title w3-center" style="line-height: 1.2;">
                <th class="w3-border-right-balance marginsH stikyColumCon" style="width: 110px;">
                  {{'segPresupuestal.catalogoCuentas.titTab1' | translate}}
                </th>
                <th class="w3-border-right-balance stikyColumCon" style="min-width: 200px;">
                  <div class="tituloIcono">
                    <mat-icon class="iconoMen iconoIzq" (click)="contraerExpandirTodo()"
                      [matTooltip]="(!contraerExpandir
                        ? 'segPresupuestal.catalogoCuentas.expandirT'
                        : 'segPresupuestal.catalogoCuentas.contraerT') | translate">
                      {{ contraerExpandir ? 'expand_more' : 'chevron_right' }}
                    </mat-icon>
                    <span>{{ 'segPresupuestal.catalogoCuentas.titTab2' | translate }}</span>
                  </div>
                </th>     
                @for(p of periodosData; track $index){
                  <th class="w3-border-right-balance stikyColumCon" style="min-width: 150px;">{{p.nombre}}</th>
                }           
              </tr>
            </thead>
            <tbody>
              @for (cuenta of cuentasVisibles; track cuenta.id; let i = $index) {
                <tr class="w3-table-trtd" [style.cursor]="cuenta.hijos.length > 0 ? 'pointer' : 'default'" style="line-height: 1.2;">
                  <td class="borderLowDSI marginsH alinRight">{{ cuenta.codigo }}</td>
                  <td class="borderAllLow alinLeft" [style.padding-left]="getIndentacion(cuenta)">
                    @if (cuenta.hijos.length > 0) {
                      <mat-icon class="material-icons-outlined" (click)="toggleExpansion(cuenta)" style="vertical-align: middle; font-size: 18px;"
                        [matTooltip]="(!cuenta.expandido 
                          ? 'segPresupuestal.estadoFinanciero.expandir' 
                          : 'segPresupuestal.estadoFinanciero.contraer') | translate">
                          {{ !cuenta.expandido ? 'expand_more' : 'chevron_right' }}
                      </mat-icon>
                    }
                    <span [style.font-weight]="cuenta.nivel === 1 ? 'bold' : 'normal'"
                    [style.margin-left]="cuenta.hijos == 0 ? '7px' : '0px'">{{ cuenta.nombre }}</span>
                  </td>
                  <!-- @if(escenarioSeleccionado.name == 'Ejecutado'){ -->
                    @for(d of cuenta.datos; track $index){
                      <td class="borderLowDSI marginsH alinRight">{{ d.valor  | formaterNumber:2:miles:decimal }}</td>
                    }
                  <!-- }@else {
                    @for(d of cuenta.presupuesto; track $index){
                      <td class="borderLowDSI marginsH alinRight">{{ d.valor  | formaterNumber:2:miles:decimal }}</td>
                    }
                  } -->
                  
                </tr>
              }
            </tbody>
          </table>
        }
      </div>
    </div>    
  </div>
</app-esqueleto-tableros>